<p-messages key="infoFacts"></p-messages>
<p-toast key="toastFacts" [style]="{marginTop: '80px'}"></p-toast>

<div class="container container-data-entry">
    <table class="table" style="width: 80%;">
        <tr *ngFor="let fact of myFacts">
            <td class="bold">{{fact}}  </td>
            <td><button *ngIf="isAdministrator()" class="btn btn-sm btn-link" (click) = "removeFact(fact)">Remove</button></td>
        </tr>
    </table>
    <hr />
    <div *ngIf="isAdministrator()">
        <div class="form-row">
            <label for="selectFact" class="col-sm-1 col-form-label prd-label">Choose Fact</label>
            <div class="col-md-9">
                <select  #fList1 class="form-control" id="selectFact" [(ngModel)]="someFactText" (change)="addFact(someFactText)" title="Select Fact you wish to add">
                    <option *ngFor="let fact of factsChoiceList">{{fact.fact}}</option>
                </select>
            </div>
            <div class="col-md-1" hidden>
                <button class="btn-success btn-sm" (click)="addFact(someFactText)">Add</button>
            </div>
        </div>
        <hr />
        <div class="form-row">
            <label for="selectRequestFinding" class="col-sm-2 col-form-label prd-label">Written Finding of Facts</label>
            <select class="col-sm-2" id="selectRequestFinding" [(ngModel)]="requestFinding" (change)="dataChange()">
                <option value="Yes">Are Requested</option>
                <option value="No">Are NOT Requested</option>
            </select>
            <label for="selectClaimRefund" class="col-sm-2 col-md-offset-1 col-form-label prd-label">Claim for Refund</label>
            <select class="col-sm-2" id="selectClaimRefund" [(ngModel)]="claimRefund" (change)="dataChange()">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
            </select>
        </div>
    </div>
</div>
